import { FormControl } from '@angular/forms';
import { CourseService } from 'src/app/core/services/course.service';
import { Component, OnInit } from '@angular/core';
import { Course } from '../../core/models/course';
import { BaseComponent } from 'src/app/components/base/base.component';
import { BaseService } from 'src/app/core/services/base.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Teacher } from '../../core/models/teacher';
import { TeacherService } from '../../core/services/teacher.service';
import { EnrollmentService } from '../../core/services/enrollment.service';
import { Enrollment } from '../../core/models/enrollment';
import { DatePipe } from '@angular/common';
import GLightbox from 'glightbox';
import { Rating } from 'src/app/core/models/rating';
import { Cart } from '../../core/models/cart';
import { CartService } from '../../core/services/cart.service';

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss']
})
export class CourseDetailsComponent extends BaseComponent implements OnInit {

  course = {} as Course;
  studentNumber: number;

  teacher = {} as Teacher;
  enrollBtns: boolean = true;
  studentId: number;
  enrollment = {} as Enrollment
  enrolledStudents: Enrollment[];

  tokenValid = false;
  lightbox: any;
  academyToken: string;
  loading = false;

  ratings: Rating[];
  averageRating: number;
  stars5: Rating[] = [];
  stars4: Rating[] = [];
  stars3: Rating[] = [];
  stars2: Rating[] = [];
  stars1: Rating[] = [];

  star5Rate: string
  star4Rate: string
  star3Rate: string
  star2Rate: string
  star1Rate: string

  star5RateNum: number
  star4RateNum: number
  star3RateNum: number
  star2RateNum: number
  star1RateNum: number

  newRate = {} as Rating;

  loadingRate = false;

  newRating: boolean = true;

  cart = {} as Cart;
  cartItems: Cart[];
  constructor(
    public baseService: BaseService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private teacherService: TeacherService,
    private enrollmentService: EnrollmentService,
    public datepipe: DatePipe,
    private courseService: CourseService,
    private cartService: CartService
  ) { super() }

  ngOnInit(): void {
    this.academyToken = localStorage.getItem('academyToken');
    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    const isTeacher = localStorage.getItem('isTeacher');
    if (isTeacher === 'true') {
      this.enrollBtns = false;
    }
    else {
      this.enrollBtns = true;
      var studId = localStorage.getItem('studentId');
      this.studentId = Number(studId);
    }

    this.loadData();
  }

  showPdf() {
    window.open(this.baseService.appUrl + this.course.pdfLink, '_blank')
  }

  showTimeTable() {
    window.open(this.baseService.appUrl + this.course.timeTableLink, '_blank')
  }

  loadData() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.course = data.course.result.returnData;
        this.studentNumber = this.course.enrollments.length;

        this.lightbox = GLightbox({
          'href': this.course.introLink,
          'type': 'video',
          'source': 'youtube', //vimeo, youtube or local
          'width': 900,
          'autoplayVideos': true,
        });

        // console.log(this.course)
        if (this.course.status === 'Completed' || this.course.status === 'Finished' || this.course.status === 'Closed') {
          this.enrollBtns = false;
        }

        if (this.studentId !== undefined) {
          this.cartService.getAll(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data: any) => {
              this.cartItems = data.result.returnData;
              const cartItems = this.cartItems.map(item => item.courseId);
              let isExist = cartItems.includes(this.course.id);
              if (isExist) {
                this.enrollBtns = false;
              }
            }
          )
        }


        const enrolledStudents = this.course.enrollments.map(item => item.studentId);
        let isExist = enrolledStudents.includes(this.studentId);
        if (isExist) {
          this.enrollBtns = false;
        }

        this.teacherService.get(this.course.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            this.teacher = data.result.returnData
          }
        )

        this.courseService.getCourseRating(this.course.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            const roundToHundredth = (value) => {
              return Number(value.toFixed(1));
            };

            this.averageRating = roundToHundredth(data.result.returnData);

          }
        )

        this.courseService.getALLCourseRating(this.course.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            this.ratings = data.result.returnData;


            const enrollmentForRating = this.course.enrollments.map(item => item.studentId);
            let enrollmentForRatingStudent = enrolledStudents.includes(this.studentId);


            const ratingsAlreadyExist = this.ratings.map(item => item.studentId);
            let ratingsAlreadyExistStudent = ratingsAlreadyExist.includes(this.studentId);

            // console.log(this.course.enrollments);
            // console.log(this.ratings);
            // console.log(enrollmentForRatingStudent);
            // console.log(ratingsAlreadyExistStudent);

            if (enrollmentForRatingStudent && !ratingsAlreadyExistStudent) {
              this.newRating = true;
            }
            else if (enrollmentForRatingStudent && ratingsAlreadyExistStudent) {
              this.newRating = false;
            }
            else if (!enrollmentForRatingStudent) {
              this.newRating = false;
            }


            const roundToHundredth = (value) => {
              return Number(value.toFixed(0));
            };

            this.ratings.forEach(element => {
              if (element.value === 5) {
                this.stars5.push(element);
              }
              else if (element.value === 4) {
                this.stars4.push(element);
              }
              else if (element.value === 3) {
                this.stars3.push(element);
              }
              else if (element.value === 2) {
                this.stars2.push(element);
              }
              else if (element.value === 1) {
                this.stars1.push(element);
              }
            });
            this.star5Rate = roundToHundredth(((this.stars5.length / this.ratings.length) * 100)).toString() + '%';
            this.star4Rate = roundToHundredth(((this.stars4.length / this.ratings.length) * 100)).toString() + '%';
            this.star3Rate = roundToHundredth(((this.stars3.length / this.ratings.length) * 100)).toString() + '%';
            this.star2Rate = roundToHundredth(((this.stars2.length / this.ratings.length) * 100)).toString() + '%';
            this.star1Rate = roundToHundredth(((this.stars1.length / this.ratings.length) * 100)).toString() + '%';

            if (this.star5Rate === 'NaN%') { this.star5Rate = '0%' }
            if (this.star4Rate === 'NaN%') { this.star4Rate = '0%' }
            if (this.star3Rate === 'NaN%') { this.star3Rate = '0%' }
            if (this.star2Rate === 'NaN%') { this.star2Rate = '0%' }
            if (this.star1Rate === 'NaN%') { this.star1Rate = '0%' }


            this.star5RateNum = roundToHundredth(((this.stars5.length / this.ratings.length) * 100))
            this.star4RateNum = roundToHundredth(((this.stars4.length / this.ratings.length) * 100))
            this.star3RateNum = roundToHundredth(((this.stars3.length / this.ratings.length) * 100))
            this.star2RateNum = roundToHundredth(((this.stars2.length / this.ratings.length) * 100))
            this.star1RateNum = roundToHundredth(((this.stars1.length / this.ratings.length) * 100))
          }
        )
      });
  }

  ratingcontrol = new FormControl(0);
  rate() {
    // console.log(this.ratingcontrol)
    if (this.ratingcontrol.value === 0 && this.ratingcontrol.pristine === true) {
    }
    else {
      this.loadingRate = true;
      this.newRate.studentId = this.studentId;
      this.newRate.courseId = this.course.id;
      this.newRate.value = this.ratingcontrol.value;
    }
  }

  sendRate() {
    this.courseService.rateCourse(this.newRate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.loadingRate = false;
        this.alertService.success(this.translate.instant('Evaluated'))
      }
    )
  }


  viewTeacherProfile(id) {
    this.router.navigate(['/teacherprofile/edit', id]);
  }


  enroll() {
    debugger
    this.loading = true;
    if (this.course.price === 0 && this.course.offerPrice === 0) {
      this.enrollment.studentId = this.studentId;
      this.enrollment.academyToken = this.academyToken;
      this.enrollment.favorite = true;
      this.enrollment.enrolled = true;
      this.enrollment.courseId = this.course.id;
      this.enrollment.enrollmentDate = this.datepipe.transform(new Date());
      this.enrollmentService.enrollment(this.enrollment).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          if (data.result.message.type === 'Success') {
            this.loading = false;
            this.alertService.success(this.translate.instant('enrolledSucs'));
            this.router.navigate(['/student-courses/edit', this.studentId]);
          }
          else if (data.result.message.content === 'This Course is not Available right now') {
            this.alertService.error(this.translate.instant('thisCourseisNotAvailable'));
          }
        }
      )
    }

    else if (this.course.offerPrice === 0 && this.course.price !== 0) {

      this.cart.courseId = this.course.id;
      this.cart.courseNameAR = this.course.courseNameAr;
      this.cart.date = new Date;
      this.cart.offerPrice = 0;
      this.cart.price = this.course.price;
      this.cart.studentId = this.studentId;
      this.cart.teacherId = this.course.teacherId;
      this.cart.thumbNail = this.course.thumbNail;

      this.cartService.addToCart(this.cart).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data:any) => {
          // console.log(data)
          if(data.result.message.type === 'Success') {
            this.alertService.success(this.translate.instant('addedToCart'));
            this.cartService.getAll(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (data: any) => {
                this.cartItems = data.result.returnData;
                const cartItems = this.cartItems.map(item => item.courseId);
                let isExist = cartItems.includes(this.course.id);
                if (isExist) {
                  this.enrollBtns = false;
                  this.loading = false;
                }
              }
            )
          }
          else {
            this.alertService.error(this.translate.instant('errorOcc'));
          }
        }
      )
    }

    else if (this.course.offerPrice !== 0 && this.course.price !== 0) {
      this.cart.courseId = this.course.id;
      this.cart.courseNameAR = this.course.courseNameAr;
      this.cart.date = new Date;
      this.cart.offerPrice = this.course.offerPrice;
      this.cart.price = this.course.price;
      this.cart.studentId = this.studentId;
      this.cart.teacherId = this.course.teacherId;
      this.cart.thumbNail = this.course.thumbNail;

      this.cartService.addToCart(this.cart).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data:any) => {
          // console.log(data)
          if(data.result.message.type === 'Success') {
            this.alertService.success(this.translate.instant('addedToCart'));
            this.cartService.getAll(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
              (data: any) => {
                this.cartItems = data.result.returnData;
                const cartItems = this.cartItems.map(item => item.courseId);
                let isExist = cartItems.includes(this.course.id);
                if (isExist) {
                  this.enrollBtns = false;
                  this.loading = false;
                }
              }
            )
          }
          else {
            this.alertService.error(this.translate.instant('errorOcc'));
          }
        }
      )
    }
  }

  loginFirst() {
    this.router.navigate(['/login']);
  }

}
